var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5664 4.5664C20.6408 4.49202 20.6998 4.40372 20.74 4.30653C20.7803 4.20935 20.801 4.10519 20.801 4C20.801 3.89481 20.7803 3.79065 20.74 3.69347C20.6998 3.59628 20.6408 3.50798 20.5664 3.4336C20.492 3.35922 20.4037 3.30022 20.3065 3.25996C20.2093 3.21971 20.1052 3.19899 20 3.19899C19.8948 3.19899 19.7906 3.21971 19.6935 3.25996C19.5963 3.30022 19.508 3.35922 19.4336 3.4336L12 10.8688L4.56639 3.4336C4.492 3.35922 4.4037 3.30022 4.30652 3.25996C4.20934 3.21971 4.10518 3.19899 3.99999 3.19899C3.89479 3.19899 3.79063 3.21971 3.69345 3.25996C3.59627 3.30022 3.50797 3.35922 3.43358 3.4336C3.3592 3.50798 3.3002 3.59628 3.25995 3.69347C3.21969 3.79065 3.19897 3.89481 3.19897 4C3.19897 4.10519 3.21969 4.20935 3.25995 4.30653C3.3002 4.40372 3.3592 4.49202 3.43358 4.5664L10.8688 12L3.43358 19.4336C3.28337 19.5838 3.19897 19.7876 3.19897 20C3.19897 20.2124 3.28337 20.4162 3.43358 20.5664C3.5838 20.7166 3.78754 20.801 3.99999 20.801C4.21243 20.801 4.41617 20.7166 4.56639 20.5664L12 13.1312L19.4336 20.5664C19.5838 20.7166 19.7875 20.801 20 20.801C20.2124 20.801 20.4162 20.7166 20.5664 20.5664C20.7166 20.4162 20.801 20.2124 20.801 20C20.801 19.7876 20.7166 19.5838 20.5664 19.4336L13.1312 12L20.5664 4.5664Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b74820b44a1c65f9da26b8f60fb36a40.svg";
export { ForwardRef as ReactComponent };